$(document).ready(function () {


  function refreshCartDrawer() {
    // $.get(window.location.pathname, function (response) {
    //     const updatedCartDrawer = $(response).find('.cart_content--js');
    //     $('.cart_content--js').html(updatedCartDrawer.html());
    // });

    $.get(window.location.pathname, function (response) {
      const updatedNum = $(response).find('.bolde_header-buttons');
      $('.bolde_header-buttons').html(updatedNum.html());
    });


  }

  $(document).on("click", ".bolde_header-cart-icon", function (evt) {
    evt.preventDefault();
    // $('.cd_outer').show();
    // setTimeout(function () {
    //     $('.cd_outer').addClass('active');
    // }, 100); 

    window.Rebuy.SmartCart.show();
  });

  $(document).on("click", '.header__icon--cart', function (evt) {
    evt.preventDefault();
    // $('.cd_outer').show();
    // setTimeout(function () {
    //     $('.cd_outer').addClass('active');
    // }, 100);
    window.Rebuy.SmartCart.show();
  });

  $('.bolde_upsell-atc').click(function (evt) {
    evt.preventDefault();
    var currentId = $(this).attr('data-id');
    var currentQty = 1;
    var data;
    data = {
      id: currentId,
      quantity: currentQty,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // $('.cd_outer').show();
        // setTimeout(function () {
        //     $('.cd_outer').addClass('active');
        // }, 100);
        // refreshCartDrawer();
        refreshCartDrawer();
      },
      error: function () {
        alert('Error adding item to the cart.');
      }
    });
  });

  $('.bolde_access-btn').click(function (evt) {
    evt.preventDefault();
    var currentId = $(this).attr('data-id');
    var currentQty = 1;
    var data;
    data = {
      id: currentId,
      quantity: currentQty,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // $('.cd_outer').show();
        // setTimeout(function () {
        //     $('.cd_outer').addClass('active');
        // }, 100);
        // refreshCartDrawer();
        refreshCartDrawer();
      },
      error: function () {
        alert('Error adding item to the cart.');
      }
    });
  });

  $('.bb-addon_btn').click(function () {
    const currentId = $(this).attr('data-id');
    const currentQty = 1;
    const items = [{ id: currentId, quantity: currentQty, }];

    console.log(items);

    $.post('/cart/add.js', { items: items }, function () {
      refreshCartDrawer();
    }, 'json').fail(function () {
      alert('Error adding item to the cart.');
    });
  });

  $('.bb-product-atc_primary-classic').click(function () {
    var currentId = $(this).attr('data-id');
    var currentQty = $('.bold_classic-qty-val').html();
    var data;
    data = {
      id: currentId,
      quantity: currentQty,
    };

    console.log(data);

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // $('.cd_outer').show();
        // setTimeout(function () {
        //     $('.cd_outer').addClass('active');
        // }, 100);
        // refreshCartDrawer();
        refreshCartDrawer();
      },
      error: function () {

      }
    });
  });

  $('.bb-product-atc_primary').click(function () {
    const currentId = $(this).attr('data-id');
    const currentQty = 1;
    const items = [{ id: currentId, quantity: currentQty }];

    const addons = $('.bb-addons_container.v2 .bb-addons_cell.active');
    addons.length && addons.each(function () {
      items.push({ id: $(this).attr('data-id'), quantity: 1 });
    });

    console.log(items);

    $.post('/cart/add.js', { items: items }, function () {
      refreshCartDrawer();
    }, 'json').fail(function () {
      // Optionally handle error here
    });
  });

  $(document).on("click", ".bolde_item-additional-product--atc", function (evt) {

    $(this).closest('.cd_content').find('.cd_item').addClass('loading');
    evt.preventDefault();
    var $btn = $(this);
    var currentId = $btn.attr('data-id');

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: currentId,
        quantity: 1
      },
      success: function () {
        // refreshCartDrawer();
        refreshCartDrawer();
      }
    });
  });


  $(document).on("click", ".bolde_cart_upsell_btn", function (evt) {
    evt.preventDefault();
    var $btn = $(this);
    $btn.find('.upsell_btn_content').hide();
    $btn.find('.upsell_btn_loader').css('display', 'block');

    var mode = $btn.attr('data-mode');
    var currentId = $btn.attr('data-id');
    var currentQty = 1;

    var upsellSource = (mode === 'pp') ? 'Upsell from product page' : 'Upsell from cart';

    var data = {
      id: currentId,
      quantity: currentQty
    };

    console.log("Adding upsell product:", data);

    // Step 1: Add product to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(cart => {
        console.log("Upsell product added:", cart);

        // Step 2: Get current cart
        return fetch('/cart.js')
          .then(response => response.json());
      })
      .then(cartData => {
        console.log("Cart data before attribute update:", cartData);

        // Step 3: Merge in the new order attribute
        let updatedAttributes = cartData.attributes || {};
        updatedAttributes["Upsell Source"] = upsellSource;

        // Step 4: Update cart with order attribute
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: updatedAttributes })
        });
      })
      .then(response => response.json())
      .then(updatedCart => {
        console.log("Cart updated with Upsell Source:", updatedCart);

        if (mode === 'pp') {
          $('.cd_outer').show();
          setTimeout(() => $('.cd_outer').addClass('active'), 100);
        }

        refreshCartDrawer();
        $btn.find('.upsell_btn_content').show();
        $btn.find('.upsell_btn_loader').hide();
        $('.col_pp_upsell_outer').hide();
      })
      .catch(error => {
        console.error('Upsell error:', error);
        alert('Something went wrong. Please try again.');
      });
  });

  $(document).on("click", ".cd_item_upgrade_to_sub", function (evt) {
    $(this).html('Upgrading...');

    var currentId = $(this).attr('data-id');
    var newSellingPlanId = $(this).attr('data-selling-plan-id');
    var oldId = $(this).attr('data-old-id');

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        id: currentId,
        quantity: 1,
        selling_plan: newSellingPlanId
      },
      success: function () {

        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: {
            id: oldId,
            quantity: 0
          },
          success: function () {
            refreshCartDrawer();
          }
        });
      }
    });
  });


  $(".col_pp_Atc_main__js").click(function () {
    $(this).addClass('loading');
    var currentMode = $(".col_product-mode.active").attr("data");
    var currentId;
    var data;
    var sellingId = $(".col_product_variant.active").attr("data-selling-plan");
    if (currentMode == "sub") {
      currentId = $(".col_product_variant.active").attr("data-sub-id");
      data = {
        id: currentId,
        quantity: 1,
        selling_plan: sellingId,
      };
    } else {
      currentId = $(".col_product_variant.active").attr("data-id");
      data = {
        id: currentId,
        quantity: 1,
      };
    }

    console.log(data);



    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // $('.cd_outer').show();
        // setTimeout(function () {
        //     $('.cd_outer').addClass('active');
        // }, 100);
        // refreshCartDrawer();
        // $(".col_pp_Atc_main__js").removeClass('loading');
        refreshCartDrawer();
      },
      error: function () {
        alert('Error adding item to the cart.');
        $(".col_pp_Atc_main__js").removeClass('loading');
      }
    });
  });

  document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
    const smartcart = event.detail.smartcart;
    const item = event.detail.item;

    refreshCartDrawer();
  });

  document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
    const smartcart = event.detail.smartcart;
    const item = event.detail.item;

    refreshCartDrawer();
  });

  document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
    const smartcart = event.detail.smartcart;
    const item = event.detail.item;

    refreshCartDrawer();
  });

  $('.cd_outer').click(function (e) {
    if (!$(e.target).closest('.cd_inner').length) {
      $('.cd_outer').removeClass('active');
      setTimeout(function () {
        $('.cd_outer').hide();
      }, 500);
    }
  });

  $(document).on("click", ".cd_close", function () {
    $('.cd_outer').removeClass('active');
    setTimeout(function () {
      $('.cd_outer').hide();
    }, 500);
  });


  $(document).on("click", ".cd_item-plus", function () {
    $(this).closest('.cd_item').addClass('loading');
    var currentVal = parseFloat($(this).closest('.cd_item').find('.cd_item-val').html());
    currentVal++;
    var currentId = $(this).closest('.cd_item').attr('data-id');

    var data = {
      "id": currentId,
      "quantity": currentVal
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function () {
        console.log(data);
        refreshCartDrawer();
      }
    });
  });

  $(document).on("click", ".cd_item-remove", function () {
    $(this).closest('.cd_item').addClass('loading');
    var currentId = $(this).closest('.cd_item').attr('data-id');

    var data = {
      "id": currentId,
      "quantity": 0
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function () {
        console.log(data);
        refreshCartDrawer();
      }
    });
  });

  $(document).on("click", ".cd_item-minus", function () {
    $(this).closest('.cd_item').addClass('loading');
    var currentVal = parseFloat($(this).closest('.cd_item').find('.cd_item-val').html());
    currentVal--;
    var currentId = $(this).closest('.cd_item').attr('data-id');

    var data = {
      "id": currentId,
      "quantity": currentVal
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function () {
        console.log(data);
        refreshCartDrawer();
      }
    });
  });



});